document.addEventListener('DOMContentLoaded', function () {
  var productPage = document.querySelector('.product-page');
  if (!productPage) return;

  // Thumbnail switching
  var thumbs = productPage.querySelectorAll('.product-page__thumb');
  var mainImage = productPage.querySelector('.product-page__main-image img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      mainImage.setAttribute('src', thumb.dataset.fullSrc);
    });
  });

  // Quantity stepper
  var qtyInput = productPage.querySelector('.product-page__qty-input');
  var decreaseBtn = productPage.querySelector('[data-qty-decrease]');
  var increaseBtn = productPage.querySelector('[data-qty-increase]');

  if (qtyInput && decreaseBtn && increaseBtn) {
    decreaseBtn.addEventListener('click', function () {
      var value = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, value - 1);
    });

    increaseBtn.addEventListener('click', function () {
      var value = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = value + 1;
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('ProductForm');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var formData = new FormData(form);
    var submitBtn = form.querySelector('button[type="submit"]');
    submitBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        submitBtn.disabled = false;

        // Update cart count
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
 var subtotalEl = document.getElementById('CartDrawerSubtotal');
    if (subtotalEl) {
      subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
    }

            });
          });

        // Refresh drawer items
        fetch('/?section_id=cart-drawer-items')
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newItems = doc.getElementById('CartDrawerItems');
            var currentItems = document.getElementById('CartDrawerItems');
            if (newItems && currentItems) {
              currentItems.innerHTML = newItems.innerHTML;
            }
          });

        // Open drawer
        var drawer = document.getElementById('CartDrawer');
        if (drawer) {
          drawer.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
      });
  });
});